// removed by extract-text-webpack-plugin
module.exports = {"cardsWrapper":"KeyReferenceDataCards__cardsWrapper___3_Scu","infoBox":"KeyReferenceDataCards__infoBox___1fu-U","infoBoxFirst":"KeyReferenceDataCards__infoBoxFirst___2BuFI","infoBoxLast":"KeyReferenceDataCards__infoBoxLast___1kT0A","heading":"KeyReferenceDataCards__heading___3Fym6","bottomHeading":"KeyReferenceDataCards__bottomHeading___1sYkP","value":"KeyReferenceDataCards__value___7Wjaq","sectionDivider":"KeyReferenceDataCards__sectionDivider___sawdu","sidePanelTitle":"KeyReferenceDataCards__sidePanelTitle___3LkfY","summaryHeader":"KeyReferenceDataCards__summaryHeader___3GzGK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/KeyReferenceDataCards/KeyReferenceDataCards.less
// module id = 1220
// module chunks = 0